import { IUserPrivacy } from '../models/user-privacy-model';
import { UserPrivacy } from '../models/user-privacy-viewmodel';

/**
 * Mapper for the User Privacy service
 */

export default class UserPrivacyMapper {
    public mapMapper(item: any, mapper: Function) {
        if (item) {
            return item.map((i: any) => mapper(i));
        } return [];
    }

    public mapUserPrivacy(item: IUserPrivacy): UserPrivacy {
        return new UserPrivacy(
            item.showWorkPhoneNumber,
            item.showMobilePhoneNumber,
            item.showRoomNumber
        );
    }
}